import { US } from './country-codes';

export const CustomsReason = Object.freeze({
  NotRequired: 'NotRequired',
  InternationalShipment: 'InternationalShipment',
  UnitedStatesMilitaryAddress: 'UnitedStatesMilitaryAddress',
  UnitedStatesTerritoryOrProtectorate: 'UnitedStatesTerritoryOrProtectorate',
  BfpoAddress: 'BfpoAddress',
  UnitedKingdomLocation: 'UnitedKingdomLocation',
  SpecialTerritoryRequirement: 'SpecialTerritoryRequirement',
  ChannelIslandTransport: 'ChannelIslandTransport',
  RequireWindsorDeclaration: 'RequireWindsorDeclaration',
  RequireMovementIndicator: 'RequireMovementIndicator',
});
export const recipientCountriesForTariffs = [US];
